<template>
  <el-dialog
    :visible.sync="visible"
    :title="!dataForm.id ? $t('add') : $t('update')"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmitHandle()"
      :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'"
    >
      <div class="line-box">
        <el-form-item label="渠道名称" prop="channelName">
        <el-input
          class="styW1"
          v-model="dataForm.channelName"
          placeholder="渠道名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="编号" prop="number">
        <el-input
          class="styW1"
          v-model="dataForm.number"
          placeholder="编号"
        ></el-input>
      </el-form-item>
      <el-form-item label="渠道编码" prop="channelCode">
        <el-input
          class="styW1"
          v-model="dataForm.channelCode"
          placeholder="渠道编码"
        ></el-input>
      </el-form-item>
      <el-form-item label="余额" prop="balance">
        <el-input
          class="styW1"
          v-model="dataForm.balance"
          placeholder="余额"
        ></el-input>
      </el-form-item>
      <el-form-item label="花费" prop="cost">
        <el-input
          class="styW1"
          v-model="dataForm.cost"
          placeholder="花费"
        ></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-input
          class="styW1"
          v-model="dataForm.type"
          placeholder="类型"
        ></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select
          class="styW1"
          v-model="dataForm.status"
          filterable
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="排序" prop="sortOrder">
        <el-input
          class="styW1"
          v-model="dataForm.sortOrder"
          placeholder="排序"
        ></el-input>
      </el-form-item>
      <el-form-item label="入库方式" prop="entryMethod">
       <el-select
          class="styW1"
          v-model="dataForm.entryMethod"
          filterable
          clearable
          multiple
          placeholder="请选择"
        >
          <el-option
            v-for="item in entryMethodList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="话术" prop="script">
        <el-input class="styW1" v-model="dataForm.script" placeholder="话术"></el-input>
      </el-form-item>
      <el-form-item label="回调系统" prop="callbackSystem">
        <el-input class="styW1"
          v-model="dataForm.callbackSystem"
          placeholder="回调系统"
        ></el-input>
      </el-form-item>
      
        <el-form-item label="AppId" prop="appId">
        <el-input class="styW1" v-model="dataForm.appId" placeholder="AppId"></el-input>
      </el-form-item>
      <el-form-item label="AppSecret" prop="appSecret" >
        <el-input class="styW1"
          v-model="dataForm.appSecret"
          placeholder="AppSecret"
        ></el-input>
      </el-form-item>
      <el-form-item label="上线时间" prop="releaseDate">
        <el-date-picker
          v-model="dataForm.releaseDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      </div>
      <el-form-item label="准入区域" prop="accessArea">
        <el-select
            style="width: 90%;"
            v-model="dataForm.accessArea"
            filterable
            clearable
            multiple
            placeholder="请选择城市"
          >
            <el-option
              v-for="item in allCityList"
              :key="item.value"
              :label="item.Name"
              :value="item.Name"
            >
            </el-option>
          </el-select>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="qx()">{{ $t("cancel") }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
        $t("confirm")
      }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from "lodash/debounce";
import cityList from "../../../utils/city_all.json";
import { number } from "echarts";
export default {
  data() {
    return {
      visible: false,
      allCityList: [],
      statusList: [
        { value: 1, label: "启用" },
        { value: 0, label: "停用" },
      ],
      entryMethodList:[
        { value:"手动创建", label: "手动创建" },
        { value:"模板导入", label: "模板导入" },
        { value:"推广表单", label: "推广表单" },
        { value:"系统对接", label: "系统对接" },
      ],
      dataForm: {
        id: "",
        channelName: "",
        number: "",
        channelCode: "",
        balance: "",
        cost: "",
        type: "自建",
        status: "",
        sortOrder: "",
        entryMethod: "",
        script: "",
        callbackSystem: "",
        accessArea: "",
        appId: "",
        appSecret: "",
        releaseDate: "",
      },
    };
  },
  computed: {
    dataRule() {
      return {
        channelName: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        number: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        channelCode: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        balance: [
          {
            required: false,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        cost: [
          {
            required: false,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        type: [
          {
            required: false,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        sortOrder: [
          {
            required: false,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        entryMethod: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        script: [
          {
            required: false,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        callbackSystem: [
          {
            required: false,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        accessArea: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        appId: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        appSecret: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        releaseDate: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
      };
    },
  },
  methods: {
    init() {
      this.visible = true;
      console.log(12, cityList);
      this.allCityList = cityList.filter((item) => {
        // 检查 code 是否为两位数
        return item.Code > 99;
      });

      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        if (this.dataForm.id) {
          this.getInfo();
        }
      });
    },
    qx(){
      this.visible = false;
      this.dataForm= {
        id: "",
        channelName: "",
        number: "",
        channelCode: "",
        balance: "",
        cost: "",
        type: "自建",
        status: "",
        sortOrder: "",
        entryMethod: "",
        script: "",
        callbackSystem: "",
        accessArea: "",
        appId: "",
        appSecret: "",
        createDate:"",
        updateTime:"",
        releaseDate: "",
      }
    },
    // 获取信息
    getInfo() {
      this.$http
        .get(`/sys/crmchannelinfo/${this.dataForm.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data,
            accessArea:JSON.parse(res.data.accessArea),
            entryMethod:JSON.parse(res.data.entryMethod),
          };
        })
        .catch(() => {});
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function () {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          
          let dataForm = {
            ...this.dataForm,
            entryMethod: JSON.stringify(this.dataForm.entryMethod),
            accessArea: JSON.stringify(this.dataForm.accessArea),
            balance: parseFloat(this.dataForm.balance),
            cost: parseFloat(this.dataForm.cost),
            sortOrder: parseInt(this.dataForm.sortOrder),
          }
         
          this.$http[!this.dataForm.id ? "post" : "put"](
            "/sys/crmchannelinfo/",
            dataForm
          )
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg);
              }
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch(() => {});
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
  },
};
</script>
<style scoped lang="scss">
  .styW1{
    width: 260px;
  }
</style>
